<template><article><h1>The &lt;input&gt; linkage</h1>
<p><example :value="example1"></example></p>
</article></template>

<script>
  import examples from '@/examples/input.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>